module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-wrapper"
  }, [_c('svg', {
    staticClass: "svg-blob-hero",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M93.5,-127C139.9,-94.9,209.3,-92.7,221.5,-68.8C233.6,-44.8,188.6,0.9,152.4,30C116.1,59.2,88.6,71.6,64.7,104.4C40.8,137.1,20.4,190,-15.8,211.8C-51.9,233.5,-103.8,223.9,-145.4,196.9C-186.9,169.9,-218,125.4,-206.7,85C-195.3,44.5,-141.4,8,-109.7,-18.9C-77.9,-45.9,-68.4,-63.4,-53.8,-105.8C-39.2,-148.3,-19.6,-215.6,2,-218.3C23.5,-221,47,-159.1,93.5,-127Z",
      "fill": "#fff"
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('div', {
    staticClass: "inc-500-banner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hero-text"
  }, [_c('h1', {
    staticClass: "hero-text-main"
  }, [_vm._v(_vm._s(_vm.heroTextMain))]), _vm._v(" "), _c('h3', {
    staticClass: "hero-text-sub"
  }, [_vm._v(_vm._s(_vm.heroTextSub))]), _vm._v(" "), _c('div', {
    staticClass: "hero-get-demo-box"
  }, [_c('input', {
    staticClass: "hero-get-demo-input",
    attrs: {
      "type": "text",
      "placeholder": "enter your email"
    },
    on: {
      "keyup": function($event) {
        return _vm.keyListener($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "hero-get-demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.getDemoEvent
    }
  }, [_vm._v("\n        get a demo\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "phone-and-buttons"
  }, [_c('div', {
    staticClass: "hero-main-video"
  }, [(_vm.videoSrc) ? _c('video', {
    attrs: {
      "src": _vm.videoSrc,
      "playsinline": "",
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hero-main-image"
  }), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "desktop-note"
  }, [_vm._v("🍾 MikMak launches Attach for alcohol eCommerce  "), _c('a', {
    attrs: {
      "href": "/alcohol"
    }
  }, [_vm._v("Learn more here. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mobile-note"
  }, [_vm._v("🍾 MikMak launches Attach for alcohol eCommerce  "), _c('a', {
    attrs: {
      "href": "/alcohol"
    }
  }, [_vm._v("Learn more here. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atc-button-image-wrapper"
  }, [_c('img', {
    staticClass: "atc-button-amazon atc-button-image",
    attrs: {
      "src": require("../../../assets/winter-2019/checkout-amazon.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "atc-button-walmart atc-button-image",
    attrs: {
      "src": require("../../../assets/winter-2019/checkout-walmart.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "atc-button-target atc-button-image",
    attrs: {
      "src": require("../../../assets/winter-2019/checkout-target.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eed6e226"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/HeroContent/HeroContent.vue
// module id = 505
// module chunks = 0